import { ApplicationScope, Invoice, Order } from "~/api-client";
import { defineStore } from "pinia";

interface State {
}
export const useInvoiceStore = defineStore('invoice', {
  state: (): State => ({
  }),
  getters: {
  },
  actions: {
    async partiallyUpdateInvoice(invoice: Invoice, orderId: string) {
      const {$backendService, $logger, $tenant, $orderStore} = useNuxtApp();
      return $backendService.invoiceControllerApi.partiallyUpdateInvoice({
          xApplicationScope: $tenant.getTenant,
          invoiceId: invoice.id!,
          invoice: {
            status: invoice.status
          }
        }
      ).then(result => {
        $orderStore.updateInvoiceStatusOnAllOrdersState(orderId, invoice.status);
        return result;
      }).catch(error => {
        ElMessage.error('Der Rechnungsstatus konnte nicht aktualisiert werden');
        throw error;
      })
    },
    async requestInvoiceStatusChange(invoiceId: string){
      const {$backendService, $logger, $tenant, $orderStore, $subscriptionStore} = useNuxtApp();
      return $backendService.invoiceControllerApi.requestInvoiceStatusChange({
        xApplicationScope: $tenant.getTenant,
        invoiceId: invoiceId
      }).then(result => {
        $subscriptionStore.updateInvoiceRequestStatusOnCurrentSubscriptionState(result.id, result.requestStatusChange);
        return result;
      }).catch(error => {
        ElMessage.error('Der Rechnungsstatus konnte nicht aktualisiert werden');
        throw error;
      })
    },
    async getInvoiceDocument(invoice: Invoice){
      const {$backendService, $logger, $tenant} = useNuxtApp();
      return $backendService.invoiceControllerApi.getInvoiceDocument({
        xApplicationScope: $tenant.getTenant,
        invoiceId: invoice.id!
      }).catch(error => {
        $logger.error('unable to download invoice', error);
        ElMessage.error("Beim Herunterladen ist ein Fehler aufgetreten");
        throw error;
      })
    }
  }
})